/** Up to two initials from a name's first words ("Ada Reyes" gives "AR"); `fallback` when it has
 * none. */
export const initialsOf = (name: string | null | undefined, fallback = "") =>
  (name ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("") || fallback;
